import { prop, email, required, maxLength } from '@rxweb/reactive-form-validators';

export class ForgotPasswordViewModel {
    @prop()
    @required({ message: "Email is required " })
    @email({ message: "Please enter valid email address" })
    @maxLength({ value: 50 })
    email: string;
}
